import React from "react";

export function MenuIcon(){
  return (
    <g>
      <circle cx="2.5" cy="2.5" r="2.5" fill="#D9D9D9"/>
      <circle cx="2.5" cy="10" r="2.5" fill="#D9D9D9"/>
      <circle cx="2.5" cy="17.5" r="2.5" fill="#D9D9D9"/>
    </g>
  )
}